import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import BottomPopup from '@components/modals/BottomPopup';

import { generateSampleDetailsParams } from '@features/filter/static/filterUtil';
import SampleAdd from '@features/sampleDevelopment/components/SampleAdd';
import SampleRequestCard from '@features/sampleDevelopment/components/SampleRequestCard';

import { setCurrentActivePage } from '@store/actions/ActivePageAction';
import { clearDetailsPageGlobalFilter, handleFilterOfListPage } from '@store/actions/FilterAction';
import { closeLoader, openLoader } from '@store/actions/LoaderAction';

import { fetchDependentFilterList } from '@services/commonService';

const SampleDevelopment = ({ isHideSetOrder }) => {
	const [developmentList, setDevelopmentList] = useState([]);
	const [selectedIds, setSelectedIds] = useState([]);
	const [showAddSamplePopup, setShowAddSamplePopup] = useState(false);
	const [requestType, setRequestType] = useState('');
	const sampleStoreData = useSelector((store) => store.filterResponseStore);
	const filterfields = useSelector((store) => store.filterFieldStore);
	const { ...paramsData } = generateSampleDetailsParams(filterfields);
	const { id } = useParams();
	const dispatch = useDispatch();

	useEffect(() => {
		dispatch(
			setCurrentActivePage({
				id: id,
				type: 'SAMPLE_CONVERSATION',
				pageType: 'DETAILS'
			})
		);
		return () => {
			dispatch(
				setCurrentActivePage({
					id: null,
					type: '',
					pageType: 'DETAILS'
				})
			);
			dispatch(clearDetailsPageGlobalFilter());
		};
	}, []);

	useEffect(() => {
		fetchDevelopmentList();
	}, [filterfields]);

	useEffect(() => {
		if (sampleStoreData?.sampleItems) {
			setDevelopmentList(sampleStoreData?.sampleItems);
		}
	}, [sampleStoreData]);

	const fetchDevelopmentList = () => {
		dispatch(openLoader());
		Promise.all([
			dispatch(
				fetchDependentFilterList(
					{ type: 'SAMPLE_DEVELOPMENT', idUrl: `${id}/products/filter-options` },
					paramsData
				)
			),
			dispatch(
				handleFilterOfListPage(
					{ type: 'getProductsWithSampleItemByCollection', idUrl: `${id}/products` },
					paramsData,
					false
				)
			)
		]).finally(() => dispatch(closeLoader()));
	};

	const handleCheckbox = (e, value) => {
		if (e.target.checked) {
			setSelectedIds((prevState) => [...prevState, value]);
		} else {
			let ids = selectedIds.filter((item) => parseInt(item) !== parseInt(value));
			setSelectedIds(ids);
		}
	};

	const handleAllCheckbox = (e) => {
		if (e.target.checked) {
			let ids = developmentList?.map((item) => item.productId);
			setSelectedIds(ids);
		} else {
			setSelectedIds([]);
		}
	};

	const onGetSelectedDesigns = () => {
		let availableSampleList = [];
		let availableCostingList = [];
		let availablePhotoshootList = [];
		let filteredSamplelist = developmentList
			?.filter((item) => {
				if (!item?.currentActivity) {
					return parseInt(item.productId);
				}
			})
			.map((item) => parseInt(item.productId));
		availableSampleList = selectedIds.filter((item) => filteredSamplelist.includes(item));
		let filteredCostinglist = developmentList
			?.filter((item) => {
				if (!item?.isCostingRequested) {
					return parseInt(item.productId);
				}
			})
			.map((item) => parseInt(item.productId));

		availableCostingList = selectedIds.filter((item) => filteredCostinglist.includes(item));

		let filteredPhotolist = developmentList
			?.filter((item) => {
				if (!item?.isPhotoshootRequested) {
					return parseInt(item.productId);
				}
			})
			.map((item) => parseInt(item.productId));
		availablePhotoshootList = selectedIds.filter((item) => filteredPhotolist.includes(item));

		const avialableDevelopMentLists = {
			sample: availableSampleList,
			costing: availableCostingList,
			photoshoot: availablePhotoshootList
		};

		return avialableDevelopMentLists;
	};

	const onActionClick = (type) => {
		if (type === 'CLEAR') {
			setSelectedIds([]);
		} else {
			setRequestType(type);
			setShowAddSamplePopup(true);
		}
	};

	const getSelectedDesigns = () => {
		const designs = onGetSelectedDesigns();
		switch (requestType) {
			case 'SAMPLE':
				return designs.sample;
			case 'COSTING':
				return designs.costing;
			default:
				return designs.photoshoot;
		}
	};

	return (
		<>
			<SampleRequestCard
				sampleData={{ sampleRequestItemResponseList: [...developmentList] }}
				cardType="DEVELOPMENT"
				fetchDevelopmentList={fetchDevelopmentList}
				handleCheckboxOfParent={handleCheckbox}
				handleAllCheckboxOfParent={handleAllCheckbox}
				selectedDesignIdsOfParent={selectedIds}
				sampleRequestId={sampleStoreData?.sampleRequestId}
			/>

			{selectedIds.length > 0 && (
				<BottomPopup
					length={selectedIds.length}
					type="SAMPLE_PAGE"
					selectedDesignIds={onGetSelectedDesigns()}
					onActionClick={(type) => onActionClick(type)}
					isHideSetOrder={isHideSetOrder}
				/>
			)}

			{showAddSamplePopup && (
				<SampleAdd
					requestType={requestType}
					source="DEVELOPMENT"
					selectedDesignIds={getSelectedDesigns()}
					onClose={(type) => {
						if (type !== 'CANCEL') {
							fetchDevelopmentList();
						}
						setShowAddSamplePopup(false);
						setSelectedIds([]);
					}}
				/>
			)}
		</>
	);
};

export default SampleDevelopment;
